import React, { createContext } from 'react';
import useTracking, { TrackingType } from '../hooks/tracking/useTracking';

export const TrackingContext = createContext<TrackingType | null>(null);

const TrackingProvider = ({ children }: { children?: React.ReactNode }) => {
  const tracking = useTracking();

  return (
    <TrackingContext.Provider value={tracking}>
      {children}
    </TrackingContext.Provider>
  );
};

export default TrackingProvider;
